import { BOOKING_TYPE } from "@/_old/features/dashboard-charts";

export const BOOKING_OPTIONS = {
  ALL_TYPES: { label: "filter-booking-type-all", value: 0 },
  SHARED_SPACE: {
    label: "filter-booking-type-shared-space",
    value: BOOKING_TYPE.SHARED_SPACE,
  },
  MEETING_ROOM: {
    label: "filter-booking-type-meeting-room",
    value: BOOKING_TYPE.MEETING_ROOM,
  },
  EVENT_SPACE: {
    label: "filter-booking-type-event-space",
    value: BOOKING_TYPE.EVENT_SPACE,
  },
  PRIVATE_OFFICE: {
    label: "filter-booking-type-private-office",
    value: BOOKING_TYPE.PRIVATE_OFFICE,
  },
  EXCLUSIVE_OFFICE: {
    label: "filter-booking-type-exclusive-office",
    value: BOOKING_TYPE.EXCLUSIVE_OFFICE,
  },
};
